import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { Amortizacao, OperacaoCreditoLivre } from "src/app/model/operacao-credito-livre.model";
import { OperacaoGarantida } from "src/app/model/operacao-garantida.model";
import { PermissaoService } from 'src/app/shared/permissao.service';

@Component({
    selector: 'aba-amortizacoes',
    templateUrl: 'aba-amortizacoes.component.html',
    standalone: false
})
export class AbaAmortizacoesComponent implements OnChanges, OnInit {

    @Input()
    public operacao: OperacaoCreditoLivre;
    @Input()
    public model: OperacaoGarantida;
    @Input()
    public modoEdicao: Boolean;
    @Input()
    public emInclusao: Boolean;
    @Input()
    public refreshAbaAmortizacao: number;
    @Output() aoCancelarAmortizacao: EventEmitter<number> = new EventEmitter<number>();
    @Output() aoRemoverAmortizacao: EventEmitter<number> = new EventEmitter<number>();
    @Output() aoAdicionarAmortizacao: EventEmitter<void> = new EventEmitter<void>();

    public amortizacoes: Amortizacao[] = [];

    public cancelamentoPeloGestor = false;

    public mostrarAmortizacoesAntecipadas: boolean = true;

    public temAmortizacoesAntecipadas: boolean = false;

    private nomesCampos: number[] = [];

    constructor(private permissaoService: PermissaoService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.modoEdicao || this.emInclusao) {
            let i=0;
            for (let amort of this.operacao.getAmortizacoesOrdinarias()) {
                amort.indice = i;
                i++;
            }
            this.amortizacoes = this.operacao.getTodasAmortizacoes();
            // console.log(this.amortizacoes); investigação defeito SOL00144711
            this.temAmortizacoesAntecipadas = this.amortizacoes.some(amort => amort.antecipada);
        }
        else {
            this.amortizacoes = this.operacao.getTodasAmortizacoes();
        }
        while (this.nomesCampos.length < this.amortizacoes.length) {
            this.adicionaNomeCampo();
        }
            
    }

    ngOnInit(): void {
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
            this.cancelamentoPeloGestor = resp && resp[ROLE_GESTOR_ENVIO];
          });
    }

    cancelarAmortizacaoAntecipada(idAmortizacao: number): void {
        this.aoCancelarAmortizacao.emit(idAmortizacao);
      }

    getValorAmortizacao(valor: number): string {
        return (valor === undefined) ? undefined : (Math.round(valor * 100) / 100).toFixed(2);
    }

    removerAmortizacao(i) {
        this.aoRemoverAmortizacao.emit(i);
    }

    adicionarAmortizacao() {
        this.aoAdicionarAmortizacao.emit();
    }

    exibirBotaoCancelarAmortizacao(amort: Amortizacao): boolean {
        let ehUltimaAmortizacaoAntecipada = this.ehUltimaAmortizacaoAntecipada(amort);
        let ehAntecipada = amort.antecipada;
        return ehAntecipada && ehUltimaAmortizacaoAntecipada && this.estaSemSolicitacaoDeHonra();
    }

    private estaSemSolicitacaoDeHonra(): boolean {
        const estadoSolicitacaoHonraId = this.model?.detalhe?.estadoSolicitacaoHonraAtual?.id;
        return !estadoSolicitacaoHonraId || ([0,6,9].includes(+estadoSolicitacaoHonraId));
    }

    private ehUltimaAmortizacaoAntecipada(amort: Amortizacao): boolean {
        const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;
        return operacaoCreditoLivre.getUltimaAmortizacaoAntecipada()?.id === amort.id;
      }

    adicionaNomeCampo() {
        let max = 0;
        for (let i of this.nomesCampos) {
            if (max < i) {
                max = i;
            }
        }
        this.nomesCampos.push(max+1);
    }

    nomeCampo(prefixo, i) {
        return prefixo + this.nomesCampos[i];
    }
}